import { App } from '@ps20-frontend/frontend-models';
import { AngebotsId } from './angebotsId';

export interface OwnedAngebotsId extends AngebotsId {
  ownerAppId?: App;
}

export const isOwnedByTgv = (produkt: Pick<OwnedAngebotsId, 'ownerAppId'>): boolean =>
  produkt?.ownerAppId === App.TGV;
